/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  // useEffect,
  useState,
} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
// import {Link} from 'react-router-dom'
import { useFormik } from 'formik'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
// import {RootState} from '../../../redux/store'
import {
  // useSelector,
  useDispatch,
} from 'react-redux'
import { AppDispatch } from '../../../redux/store'
import { updateAgentSlice } from '../../../redux/features/agentSlice'
import { fetchOutdatedProperty } from '../../../redux/features/propertySlice'
import { fetchPropertySummary } from '../../../redux/features/propertySlice'
import { fetchStates } from '../../../redux/features/stateAreaSlice'
import { fetchSearchProperty } from '../../../redux/features/masterDraft'
import { fetchPackage } from '../../../redux/features/packageSlice'
// import dashboardComponent from '../../../businessesRevamp/dashboardComponent' //to be remove once propertySlice is completed
import agentBiz from '../../../biz/agentBiz'
// import propertyMasterDraftComponent from '../../../biz/propertyMasterDraftBiz' //to be remove once masterDraftSlice is completed
// import propertyComponent from '../../../businessesRevamp/propertyComponent' //to be remove once propertySlice is completed

const loginSchema = Yup.object().shape({
  // username: Yup.string()
  // .email('Wrong email format')
  // .min(3, 'Minimum 3 symbols')
  // .max(50, 'Maximum 50 symbols')
  // .required('User name / email is required'),
  // password: Yup.string()
  // .min(3, 'Minimum 3 symbols')
  // .max(50, 'Maximum 50 symbols')
  // .required('Password is required'),
})

const initialValues = {
  username: ``,
  password: ``,
}

export function Login(props: any) {
  const dispatch = useDispatch<AppDispatch>()
  // const agentSlice = useSelector((state: RootState) => state.agent)
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      if (!values.username || !values.password) setStatus('Username/email or password is required.')
      else {
        setLoading(true)
        setSubmitting(false)
        try {
          values.username = values.username.trim();
          const agent = await agentBiz.login(values)
          if (agent) {
            if (agent.active === 'Disabled') {
              setStatus(
                'This account has been disabled. Please contact admin for further assistance.'
              )
            } else if (agent.active === 'Temporary Out of Service' && agent.companyName === 'The Roof Realty') {
              setStatus(
                'This account is temporary out of service. Please contact admin for further assistance.'
              )
            } else {
              //     if (agent.active === 'Temporary Out of Service') {
              //         agent.TOOS = true
              //       }

              // //   // const propertiesInfo = await dashboardComponent.summary(agent._id)
              // //   // const outdatedProperties = await dashboardComponent.outdatedProperties(agent._id)
              //   const packageInfo = await agentComponent.getPackage(agent._id)
              // //   // const propertyMasterDraft = await propertyMasterDraftComponent.search(agent._id, '', '', 0)
              // //   // const allProperties = await propertyComponent.search(agent._id, { active: "Active" }, 0)
              const loggedInAgent = await agentBiz.handleLoggedInAgent(agent)
              // console.log(loggedInAgent)

              //@ts-ignore
              dispatch(fetchOutdatedProperty(agent._id))
              //@ts-ignore
              dispatch(fetchPropertySummary(agent._id))
              //@ts-ignore
              dispatch(fetchStates())
              dispatch(fetchPackage())
              //@ts-ignore
              dispatch(fetchSearchProperty({ agentId: agent._id, val: '', status: '', paging: 0 }))

              // let loggedInAgent = {
              //   ...agent,
              //   // propertiesInfo,
              //   // outdatedProperties,
              //   packageInfo,
              //   // propertyMasterDraft,
              //   // allProperties,
              //   isPlotted: true,
              // }

              // if (!agent.loc || !agent.state || !agent.area || (!agent.state && !agent.area)) {
              //   loggedInAgent.isPlotted = false
              // }
              dispatch(updateAgentSlice(loggedInAgent))
            }
          }
        } catch (err: any) {
          if (err.response.status === 401) {
            setStatus('Invalid username/password. Please try again')
          } else if (err.response.status === 403) {
            setStatus('Your account has been suspended, please contact IProfoma Admin.')
          }
        } finally {
          setLoading(false)
          setSubmitting(false)
        }
      }
    }
  })

  const handleAuthState = () => {
    props.authState('FORGOT')
    formik.setSubmitting(false)
  }

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='text-center mb-11 auth-nextsix-agent-logo'>
        <img src={`${toAbsoluteUrl('/media/auth/nextsix-agent-logo.png')}`} alt='' />
      </div>
      {/* <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Or with email</span>
      </div> */}
      {formik.status && (
        <div className='mb-lg-12 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}
      <div className='fv-row mb-8'>
        <div className='auth-input-box'>
          <label className='form-label auth-input-text'>User Name / Email Address</label>
          <input
            placeholder='user name / email address'
            {...formik.getFieldProps('username')}
            className={clsx('form-control bg-transparent auth-input-field')}
            type='username'
            name='username'
            autoComplete='on'
          />
        </div>
        {/* {formik.touched.username && formik.errors.username && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.username}</span>
            </div>
          </div>
        )} */}
      </div>
      <div className='fv-row mb-3'>
        <div className='auth-input-box'>
          <label className='form-label auth-input-text'>Password</label>
          <input
            {...formik.getFieldProps('password')}
            className={clsx('form-control bg-transparent auth-input-field')}
            placeholder='password'
            type='password'
            autoComplete='off'
          />
        </div>
        {/* {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )} */}
      </div>

      <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <span></span>
        <button onClick={handleAuthState} className='auth-forgot-button' type='button'>
          forgot password
        </button>
      </div>

      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn auth-sign-in-button'
        // disabled={formik.isSubmitting || !formik.isValid}
        >
          {!loading && <span className='indicator-label'>Sign In</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Please wait...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>

      <div className='d-flex flex-center flex-column-auto'>
        <div className='d-flex align-items-center auth-account-yet'>
          <span>
            Don't have an account yet?
            <a
              href={process.env.REACT_APP_WEBSITE_DOMAIN + '/signup'}
              className='auth-register-here'
              target='_blank'
              rel="noopener noreferrer"
            >
              &nbsp;Register here
            </a>
          </span>
        </div>
      </div>
    </form>
  )
}

// const handleLoggedInAgent = async (agent: any) => {
//     if (agent.active === 'Temporary Out of Service') {
//       agent.TOOS = true
//     }

//     const packageInfo = await agentComponent.getPackage(agent._id)

//     //@ts-ignore
//     // dispatch(fetchOutdatedProperty(agent._id))
//     // //@ts-ignore
//     // dispatch(fetchPropertySummary(agent._id))
//     // //@ts-ignore
//     // dispatch(fetchStates())
//     // //@ts-ignore
//     // dispatch(fetchSearchProperty({agentId:agent._id, val:'', status:'', paging:0}))

//     let loggedInAgent = {
//       ...agent,
//       packageInfo,
//       isPlotted: true,
//     }

//     if (!agent.loc || !agent.state || !agent.area || (!agent.state && !agent.area)) {
//       loggedInAgent.isPlotted = false
//     }
//     return loggedInAgent
//     // dispatch(updateAgentSlice(loggedInAgent))
// }